import Vue from 'vue'
import Router from 'vue-router'
import home from 'components/index/index'
import goodsList from 'components/goodsList/index'
import GoodsDetails from 'components/goodsDetails/index'
import ShopCar from 'components/shoppCar/index'
import Settlement from 'components/Settlement/index'
import loginHome from 'components/Login/index'
import Alipay from 'components/Alipay/alipay'
import SetPWD1 from 'components/setPassword/setPWD1'
import SetPWD2 from 'components/setPassword/setPWD2'
import SetPWD3 from 'components/setPassword/setPWD3'
import SetPWD4 from 'components/setPassword/setPWD4'
import err404 from 'components/common/err404'
import articleList from 'components/article/list'
import member from 'components/member/index'
import replace from 'components/member/replace'
import order from 'components/member/order'
import orderDetails from 'components/member/order_details'
import collections from 'components/member/collections'
import footprint from 'components/member/footprint'
import information from 'components/member/information'
import address from 'components/member/address'
import allTenant from 'components/member/allTenant'
import payPassword from 'components/member/payPassword'
import evaluateOrder from 'components/member/evaluate_order'
import myEvaluation from 'components/member/my_evaluation'
import memberBalance from 'components/member/member_balance'
import memberScore from 'components/member/member_score'
import modifyMobilePhone from 'components/member/modifyMobilePhone'
import storedValueCard from 'components/member/stored_value_card'
import replacementGoods from 'components/member/replacement_goods'
import paySuccess from 'components/member/pay_success'
import stayPay from 'components/member/stayPay'
import returnGoodsList from 'components/member/return_goods_list'
import project from 'components/project/index'
import teamGoods from 'components/goodsList/teamGoods'
import teamOrder from 'components/member/team_order'
import viewReturns from 'components/member/viewReturns'
import teamOrderDetails from 'components/member/team_order_details'
import theFinalResults from 'components/member/the_final_results'
import myCoupon from 'components/coupon/my_coupon'
import historyCoupon from 'components/coupon/history_coupon'
import couponList from 'components/coupon/coupon_list'
import couponDetail from 'components/coupon/coupon_detail'
import activityList from 'components/activity/activity_list'
import activityDetail from 'components/activity/activity_detail'
import dragonBoatFestival from 'components/dragonBoatFestival/dragonBoatFestival'
import publicTemplate from 'components/publicTemplate/index'
import JuneOneTemplate from 'components/JuneOneTemplate/JuneOneTemplate'
import christmasTemplate from 'components/christmasTemplate/christmasTemplate'
import scoreChange from 'components/scoreChange/scoreChange'
import userAgreement from 'components/agreement/user'
import privacyAgreement from 'components/agreement/privacy'
import nationalDay from 'components/nationalDay/nationalDay'
import newYear from 'components/newYear/newYear'
import generalTemplate1 from 'components/generalTemplate1/generalTemplate1'

Vue.use(Router);
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },{
      path:'/goodslist',
      name:'goodslist',
      component:goodsList
    },{
      path:'/goodsdetails',
      name:'goodsdetails',
      component:GoodsDetails
    },{
      path:'/shopCar',
      name:'shopCar',
      component:ShopCar
    },{
      path:'/settlement',
      name:'settlement',
      component:Settlement
    },{
      path:'/loginHome',
      name:'loginHome',
      component:loginHome,
      beforeEnter:(to, from, next) => {
        if(to.path == '/goodsdetails'){
          next({path:'/goodsdetails', query: {redirect: to.query.oldData}})
        }else{
          next()
        }
        // to.path == '/goodsdetails' ? next('/goodsdetails') :next();
        // from.path == '/goods-list' ? next('/goods-list') :next();
      }
    },{
      path:'/Alipay',
      name:'Alipay',
      component:Alipay
    },{
      path:'/setPassword1',
      name:'SetPWD1',
      component:SetPWD1
    },{
      path:'/setPassword2',
      name:'SetPWD2',
      component:SetPWD2
    },{
      path:'/setPassword3',
      name:'SetPWD3',
      component:SetPWD3
    },{
      path:'/setPassword4',
      name:'SetPWD4',
      component:SetPWD4
    },{
      path:'/err404',
      name:'err404',
      component:err404
    },{
      path:'/articleList',
      name:'articleList',
      component:articleList
    },{
      path:'/member',
      name:'member',
      component:member,
      children:[
        {
          path:'/',
          name:'replace',
          component:replace
        },{
          path:'/order',
          name:'order',
          component:order
        },{
          path:'/collections',
          name:'collections',
          component:collections
        },{
          path:'/footprint',
          name:'footprint',
          component:footprint
        },{
          path:'/information',
          name:'information',
          component:information
        },{
          path:'/address',
          name:'address',
          component:address
        },{
          path:'/allTenant',
          name:'allTenant',
          component:allTenant
        },{
          path:'/evaluateOrder',
          name:'evaluateOrder',
          component:evaluateOrder
        },{
          path:'/myEvaluation',
          name:'myEvaluation',
          component:myEvaluation
        },{
          path:'/memberBalance',
          name:'memberBalance',
          component:memberBalance
        },{
          path:'/memberScore',
          name:'memberScore',
          component:memberScore
        },{
          path:'/modifyMobilePhone',
          name:'modifyMobilePhone',
          component:modifyMobilePhone
        },{
          path:'/storedValueCard',
          name:'storedValueCard',
          component:storedValueCard
        },{
          path:'/replacementGoods',
          name:'replacementGoods',
          component:replacementGoods
        },{
          path:'/returnGoodsList',
          name:'returnGoodsList',
          component:returnGoodsList
        },{
          path:'/teamOrder',
          name:'teamOrder',
          component:teamOrder
        },{
          path:'/myCoupon',
          name:'myCoupon',
          component:myCoupon
        },{
          path:'/historyCoupon',
          name:'historyCoupon',
          component:historyCoupon
        },{
          path:'/viewReturns',
          name:'viewReturns',
          component:viewReturns
        }
      ]
    },{
      path:'/orderDetails',
      name:'orderDetails',
      component:orderDetails
    },{
      path:'/payPassword',
      name:'payPassword',
      component:payPassword
    },{
      path:'/project',
      name:'project',
      component:project
    },{
      path:'/paySuccess',
      name:'paySuccess',
      component:paySuccess
    },{
      path:'/stayPay',
      name:'stayPay',
      component:stayPay
    },{
      path:'/teamGoods',
      name:'teamGoods',
      component:teamGoods
    },{
      path:'/teamOrderDetails',
      name:'teamOrderDetails',
      component:teamOrderDetails
    },{
      path:'/theFinalResults',
      name:'theFinalResults',
      component:theFinalResults
    },{
      path:'/couponList',
      name:'couponList',
      component:couponList
    },{
      path:'/couponDetail',
      name:'couponDetail',
      component:couponDetail
    },{
      path:'/activityList',
      name:'activityList',
      component:activityList
    },{
      path:'/activityDetail',
      name:'activityDetail',
      component:activityDetail
    },{
      path:'/dragonBoatFestival',
      name:'dragonBoatFestival',
      component:dragonBoatFestival
    },{
      path:'/publicTemplate',
      name:'publicTemplate',
      component:publicTemplate
    },{
      path:'/JuneOneTemplate',
      name:'JuneOneTemplate',
      component:JuneOneTemplate
    },{
      path:'/christmasTemplate',
      name:'christmasTemplate',
      component:christmasTemplate
    },{
      path:'/scoreChange',
      name:'scoreChange',
      component:scoreChange
    },{
      path:'/userAgreement',
      name:'userAgreement',
      component:userAgreement
    },{
      path:'/privacyAgreement',
      name:'privacyAgreement',
      component:privacyAgreement
    },{
      path:'/nationalDay',
      name:'nationalDay',
      component:nationalDay
    },{
      path:'/newYear',
      name:'newYear',
      component:newYear
    },{
      path:'/generalTemplate1',
      name:'generalTemplate1',
      component:generalTemplate1
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})






// WEBPACK FOOTER //
// ./src/router/index.js